
























































































































































import Vue from 'vue';
import draggable from 'vuedraggable';
import max from 'lodash/max';
import cloneDeep from 'lodash/cloneDeep';
import Ship from '@/classes/fleet/ship';
import ItemPreset, { OldItemPreset } from '@/classes/item/itemPreset';
import ItemMaster from '@/classes/item/itemMaster';
import Airbase from '@/classes/airbase/airbase';
import Item from '@/classes/item/item';

export default Vue.extend({
  name: 'ItemPreset',
  components: { draggable },
  props: {
    value: {
      type: [Ship, Airbase],
      required: true,
    },
    handleExpandItemPreset: {
      type: Function,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    items: [] as ItemMaster[],
    presets: [] as ItemPreset[],
    selectedIndex: -1,
    selectedPreset: new ItemPreset(),
    snackbar: false,
    infoText: '',
  }),
  mounted() {
    this.presets = [];
    const savedPresets = this.$store.state.itemPresets as (ItemPreset | OldItemPreset)[];
    this.presets = ItemPreset.convertOldItemPresets(savedPresets);
    this.items = this.$store.state.items as ItemMaster[];
  },
  computed: {
    disabledRegist(): boolean {
      if (this.value instanceof Airbase) {
        return this.value.items.filter((v) => v.data.id > 0).length === 0;
      }
      return this.value.items.concat(this.value.exItem).filter((v) => v.data.id > 0).length === 0;
    },
    itemView(): Item[] {
      const itemMasters = [];
      for (let i = 0; i < this.selectedPreset.items.length; i += 1) {
        const item = this.items.find((v) => v.id === this.selectedPreset.items[i].id);
        if (item) {
          itemMasters.push(new Item({ master: item, remodel: this.selectedPreset.items[i].remodel }));
        } else {
          itemMasters.push(new Item());
        }
      }
      return itemMasters;
    },
    exItemView(): Item {
      const item = this.items.find((v) => v.id === this.selectedPreset.exItem.id);

      return new Item({ master: item, remodel: this.selectedPreset.exItem.remodel });
    },
    isPresetItemEmpty(): boolean {
      return !this.selectedPreset.items.some((v) => v.id > 0) && this.selectedPreset.exItem.id === 0;
    },
  },
  methods: {
    clickedPreset(index: number) {
      if (index < this.presets.length) {
        this.selectedIndex = index;
        this.selectedPreset = cloneDeep(this.presets[index]);
      }
    },
    readyPreset() {
      const newPreset = new ItemPreset();
      const maxId = max(this.presets.map((v) => v.id));
      if (maxId) {
        newPreset.id = maxId;
      }
      newPreset.id += 1;
      newPreset.name = `Equipment preset ${newPreset.id}`;
      // 装備id一覧
      for (let i = 0; i < this.value.items.length; i += 1) {
        const item = this.value.items[i];
        newPreset.items.push({ id: item.data.id, remodel: item.remodel });
      }
      if (this.value instanceof Ship) {
        newPreset.exItem = { id: this.value.exItem.data.id, remodel: this.value.exItem.remodel };
      }

      this.selectedIndex = -1;
      this.selectedPreset = newPreset;
    },
    savePreset() {
      if (this.selectedIndex >= 0) {
        // 更新
        this.presets[this.selectedIndex] = this.selectedPreset;
      } else {
        // 新規登録
        this.presets.push(this.selectedPreset);
      }
      // ブラウザに保存
      this.$store.dispatch('updateItemPresets', this.presets);
      this.infoText = 'Preset saved.';
      this.snackbar = true;
      this.selectedIndex = -1;
      this.selectedPreset = new ItemPreset();
    },
    deletePreset() {
      this.presets = this.presets.filter((v, i) => i !== this.selectedIndex);
      // ブラウザに保存
      this.$store.dispatch('updateItemPresets', this.presets);
      this.snackbar = true;
      this.infoText = 'Preset deleted.';
      this.selectedIndex = -1;
      this.selectedPreset = new ItemPreset();
    },
    expandPreset() {
      if (this.selectedPreset) {
        this.handleExpandItemPreset(this.selectedPreset);
        this.handleClose();
      }
    },
    sortEnd() {
      for (let i = 0; i < this.presets.length; i += 1) {
        this.presets[i].id = i + 1;
      }
      this.$store.dispatch('updateItemPresets', this.presets);
    },
  },
});
